import React from 'react';
import { IconBaseProps } from 'react-icons';
import { FiInfo } from 'react-icons/fi';

const InfoIcon = (props: IconBaseProps) => {
  return <FiInfo {...props} />;
};

export default InfoIcon;
